import { RulePageViewKeys } from "./ruledetailpage.types";

export const rulePageViewValues: {
  [key in RulePageViewKeys]: RulePageViewKeys;
} = {
  overview: "overview",
  data_quality: "data_quality",
};
